module.exports = __webpack_public_path__ + "img/navigation-2.a44e8989.png";